// extracted by mini-css-extract-plugin
module.exports = {"className":"kn-IN_className__nGY4r"};